// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"640":"4f1087a2","867":"499103ce","879":"4f1087a2"}[chunkId] + ".chunk.css";
};